import { useEffect, useState } from 'react'
import {
  Navigate,
  Route,
  Routes,
  Link as RouterLink,
  useLocation,
} from 'react-router-dom'
import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Paper,
} from '@mui/material'
import {
  AccountBalanceWallet,
  Add,
  AdminPanelSettings,
  FitnessCenter,
  Person,
  SvgIconComponent,
} from '@mui/icons-material'

import { useAuth } from '../core/providers/auth'
import Login from '../core/views/login'
import Forgot from '../core/views/forgot'
import Register from '../core/views/register'
import Account from '../core/views/account'
import AccountStatsView from '../core/views/account-stats'
import CreditsAdmin from '../core/views/credits-admin'
import Home from './home'
import Workout from './workout'
import WorkoutDetails from '../views/workout-details'
import Admin from '../core/views/admin'
import { features } from '../core/config/features'

const routes: {
  path: string
  label: string
  icon: SvgIconComponent
  element: JSX.Element
}[] = [
  { path: '/', label: 'Pass', icon: FitnessCenter, element: <Home /> },
  { path: '/account', label: 'Konto', icon: Person, element: <Account /> },
]

const adminRoutes: {
  path: string
  label: string
  icon: SvgIconComponent
  element: JSX.Element
}[] = [
  { path: '/workout', label: 'Skapa Pass', icon: Add, element: <Workout /> },
  { path: '/admin', label: 'Admin', icon: AdminPanelSettings, element: <Admin /> },
  ...(features.credits
    ? [
        {
          path: '/admin/credits',
          label: 'Credits',
          icon: AccountBalanceWallet,
          element: <CreditsAdmin />,
        },
      ]
    : []),
]

export default function App() {
  const { user, admin } = useAuth()
  const [nav, setNav] = useState(0)
  const { pathname } = useLocation()

  useEffect(() => {
    const allRoutes = [...routes, ...adminRoutes]
    setNav(allRoutes.findIndex(({ path }) => path === pathname) ?? -1)
    // eslint-disable-next-line
  }, [pathname])

  if (!user)
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/register" element={<Register />} />
        <Route path="/workouts/:id" element={<WorkoutDetails />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )

  return (
    <Box sx={{ marginBottom: 9 }}>
      <Routes>
        {routes.map(({ path, element }, key) => (
          <Route key={key} path={path} element={element} />
        ))}
        <Route path="/workout" element={<Workout />} />
        <Route path="/workout/:id" element={<Workout />} />
        <Route path="/account" element={<Account />} />
        <Route path="/account/stats" element={<AccountStatsView />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/credits" element={<CreditsAdmin />} />
        <Route path="/workouts/:id" element={<WorkoutDetails />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Paper
        sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}
        elevation={3}>
        <BottomNavigation
          showLabels
          value={nav}
          onChange={(_, val) => {
            setNav(val)
          }}>
          {routes.map(({ path, label, icon: Icon }, key) => (
            <BottomNavigationAction
              key={key}
              label={label}
              icon={<Icon />}
              component={RouterLink}
              to={path}
            />
          ))}
          {admin && adminRoutes.map(({ path, label, icon: Icon }, key) => (
            <BottomNavigationAction
              key={key}
              label={label}
              icon={<Icon />}
              component={RouterLink}
              to={path}
            />
          ))}
        </BottomNavigation>
      </Paper>
    </Box>
  )
}
